import {
	ChangeDetectionStrategy,
	Component,
	computed,
	Inject,
	input,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { SearchSvgComponent } from '@uc/shared/svg';
import { ClearingService, Environment, replaceDashWithSpace } from '@uc/utilities';
import { StatementsBookmarkComponent } from '@uc/shared/svg';

@Component({
	selector: 'uc-clearing-header',
	imports: [RouterLink, SearchSvgComponent, StatementsBookmarkComponent],
	templateUrl: './clearing-header.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClearingHeaderComponent {
	subject = input.required<string>();

	formattedSubject = computed(() => replaceDashWithSpace(this.subject()));
	subtitle = computed(() => this._getHeaderTitle());
	description = computed(() => this._getHeaderDescription());

	currentYear = new Date().getFullYear();
	clearingEnabled!: boolean;

	constructor(
		@Inject('environment') protected environment: Environment,
		public _clearingSrv: ClearingService,
	) {
		this.clearingEnabled = this.environment.clearingEnabled;
	}

	private _getHeaderTitle() {
		const clearingStartDate = this._clearingSrv.getStartDateString();
		return `Clearing starts on ${clearingStartDate}`;
	}

	private _getHeaderDescription() {
		const isPreClearing = this._clearingSrv.isPreClearing();
		const clearingStartDate = this._clearingSrv.getStartDateString();
		const postClearingDate = clearingStartDate.replace(
			this.currentYear.toString(),
			`${this.currentYear + 1}`,
		);

		return isPreClearing
			? `There are currently no Clearing courses available, as Clearing is yet to open for this year. Discover other ${this.formattedSubject()} courses and check back on ${clearingStartDate} to see the full list of ${this.formattedSubject()} Clearing courses.`
			: `Discover other ${this.formattedSubject()} courses and check back next year from ${postClearingDate} to find out which universities will be offering Clearing courses for ${this.formattedSubject()}.`;
	}
}
